import axios from './axiosInstances/axiosInstance';

export const getUserGiftCardBalances = () => {
  return axios.get(`/users/giftCardBalances`);
};
